module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n              Recent Incidents\n            ")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.incidentHeader,
      "items": _vm.incidentList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.editIncident(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.incident_on)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.severity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.rca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_by_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.created_on)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_by_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_on ? _vm.handy.formatDate(props.item.updated_on) : null))])])]
      }
    }], null, false, 823053037)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + ' Incident') + "\n                ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "incidentOnDate",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lIncident.incident_on_date
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "incident_on_date", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "incident_on_date", $event)
      }
    },
    model: {
      value: (_vm.incidentOnDate),
      callback: function($$v) {
        _vm.incidentOnDate = $$v
      },
      expression: "incidentOnDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Incident date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.incident_on_date),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incident_on_date", $$v)
      },
      expression: "lIncident.incident_on_date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "max": _vm.today
    },
    model: {
      value: (_vm.lIncident.incident_on_date),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incident_on_date", $$v)
      },
      expression: "lIncident.incident_on_date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.incidentOnDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.incidentOnDate.save(_vm.lIncident.incident_on_date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "incidentTime",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "lazy": "",
      "return-value": _vm.lIncident.startTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "startTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "startTime", $event)
      }
    },
    model: {
      value: (_vm.incidentTime),
      callback: function($$v) {
        _vm.incidentTime = $$v
      },
      expression: "incidentTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Incident time",
      "append-icon": "access_time",
      "clearable": "",
      "hide-details": "",
      "readonly": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.startTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "startTime", $$v)
      },
      expression: "lIncident.startTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lIncident.startTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "startTime", $$v)
      },
      expression: "lIncident.startTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.incidentTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.incidentTime.save(_vm.lIncident.startTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Priority",
      "items": ['Normal', 'Low', 'High'],
      "hide-details": ""
    },
    model: {
      value: (_vm.lIncident.severity),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "severity", $$v)
      },
      expression: "lIncident.severity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "mt-2",
    attrs: {
      "label": "Incident description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "rows": "4",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.lIncident.incident_desc),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incident_desc", $$v)
      },
      expression: "lIncident.incident_desc"
    }
  })], 1), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "mt-2",
    attrs: {
      "label": "RCA",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "rows": "4",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.lIncident.rca),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "rca", $$v)
      },
      expression: "lIncident.rca"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser()
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lIncident.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lIncident.files), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v("\n                      " + _vm._s(file.file_name) + "\n                      "), (!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": _vm.config.FILE_URL(file.file_url),
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e()])], 1)
  }), 0) : _c('span', [_vm._v("Attachment if any"), _c('br'), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(supports images, pdfs, docs and excels upto 20MB)")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lAction = 'view'
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteIncident($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:20px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b68f61d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IncidentReports.vue
// module id = 834
// module chunks = 31